import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';
import { ScrollService } from '../_services/scroll.service';


@Component({
  selector: 'app-welcome-page',
  templateUrl: './welcome-page.component.html',
  styleUrls: ['./welcome-page.component.css']
})
export class WelcomePageComponent implements OnInit {
  private subscription: Subscription = new Subscription();
  visible: boolean;
  userId: any;


  constructor(private router: Router,
    private userService: UserService,
    private scrollservice: ScrollService,
    public modalService: NgbModal,

  ) {
    this.userService.clearUser();
    this.subscription = this.scrollservice.isScroll.subscribe(a => {
      if (document.querySelector(".perfect-scrollbar").scrollTop > 0) {
        this.visible = true;

      }
      else {
        this.visible = false;
      }
    })
    this.userId = localStorage.getItem('currentUserId');
  }
  navigate(query) {
    this.router.navigate(["auth/" + { queryParams: { type: query } }]);
  }
  ngOnInit() {

  }

  open(content, ctrl) {
    console.log(content)



    if (this.userId) {

      this.modalService.open(content, { backdrop: "static" });

    } else {
      this.modalService.open(content, { backdrop: "static" });
    }

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/welcome-page.component.ts